import { createGlobalStyle, css } from 'styled-components'

/**
 * Global CSS reset shared by both routers — the App Router (`app/layout`, via
 * `ClientContainers`) and the Pages Router (`pages/_app`) — so both trees get
 * identical base styles, notably `box-sizing: border-box` and the zeroed
 * `button` padding. Previously only the App Router had these (as `app/resets.css`),
 * leaving the Pages-Router buyer portal on content-box + UA button padding.
 */
const globalResetStyles = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    max-width: 100vw;
  }

  body {
    max-width: 100vw;
    overflow-x: hidden;
    position: relative;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  button {
    background: none;
    border: none;
    color: #141a1e;
    cursor: pointer;
    padding: 0;
  }

  ul,
  ol,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  svg,
  img {
    display: block;
  }

  input {
    background: #fff;
    color: #141a1e;
  }
`

export const GlobalResets = createGlobalStyle`
  ${globalResetStyles}
`
